import React, {Component, PropTypes} from 'react';
import {observer, inject} from 'mobx-react';
import {observable, action} from 'mobx';
import Modal from '../../../Modal';
import Spinner from '../../../Spinner';
import Form, {FormBody, FormActions, TextInput, ColorInput} from '../../../Form';

@inject('maintenanceTypeStore')
@observer
class MaintenanceTypeEdit extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  slug = '/monitoring/config/maintenance_type';
  title = 'Edit Maintenance Type';

  @observable item = {
    caption : '',
    description: '',
    color: ''
  };

  @action onChangeCaption = e => this.item.caption = e.target.value;
  @action onChangeDescription = e => this.item.description = e.target.value;
  @action onChangeColor = e => this.item.color = e.target.value;

  constructor(props) {
    super(props);

    const {params: {id}, maintenanceTypeStore} = props;

    maintenanceTypeStore.fetchItem(id);
  }

  componentWillMount() {
    this.reset();
  }

  @action reset() {
    const {params: {id}, maintenanceTypeStore} = this.props;
    const foundItem = maintenanceTypeStore.findById(id);
    if (foundItem) {
      this.item = foundItem.asJson;
    }
  }

  handleSave = (e) => {
    e.preventDefault();

    const {maintenanceTypeStore} = this.props;
    maintenanceTypeStore.updateItem(this.item)
      .then(() => {
        this.context.router.push(this.slug);
      });
  }

  render() {
    const {maintenanceTypeStore, params: {id}} = this.props;

    if (maintenanceTypeStore.isLoading) {
      return <Spinner/>;
    }

    return (
      <Modal title={this.title} slug={this.slug} isSaving={maintenanceTypeStore.isSaving}>
        <Form>
          <FormBody>
            <TextInput label={'Id'} value={id} readOnly />
            <TextInput label='Caption' value={this.item.caption} onChange={this.onChangeCaption}/>
            <TextInput label='Description' value={this.item.description} onChange={this.onChangeDescription}/>
            <ColorInput label='Color' value={this.item.color} onChange={this.onChangeColor}/>
          </FormBody>

          <FormActions>
            <button onClick={this.handleSave}>Save</button>
          </FormActions>
        </Form>
      </Modal>
    );
  }
}

export default MaintenanceTypeEdit;



// WEBPACK FOOTER //
// ./src/components/Maintenance/Configuration/MaintenanceType/MaintenanceTypeEdit.js